export default __webpack_public_path__ + "static/media/ind4.0c99de2c.svg";